import { z } from 'zod'

export const ContactFormSchema = z.object({
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
  email: z.string().email('Invalid email'),
  message: z.string().min(1, 'Message is required')
}).strict()

export type ContactFormValues = z.infer<typeof ContactFormSchema>
